export const NAVIGATION_KEYS = [
  'ArrowLeft',
  'ArrowRight',
  'Backspace',
  'Delete',
  'Enter',
  'Tab',
];
